import script from "./SocialEventPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialEventPage.vue?vue&type=script&setup=true&lang=js"

import "./SocialEventPage.vue?vue&type=style&index=0&id=7ccc7926&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ccc7926"]])

export default __exports__